import React from "react";
import "./SecurityAndOperations.less";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import moment from "moment";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import TopWidget from "./TopWidget/TopWidget";
import IncidentsTable from "../Maintenance/IncidentsTable";
import HealthAndSafetyBarChart from "../HealthAndSefty/HealthAndSeftyBarChart";
import HealthAndSeftyGrphChart from "../HealthAndSefty/HealthAndSeftyGrphChart";
import {
  GetSectionPermission,
  IsSectionVisible,
  kpiRadioSlider
} from "../../../utils/helper";
import { SECTIONS, standardDateFormat } from "../../../constants/appConstants";
import SliderDatePicker from "../../common/SliderDatePicker/SliderDatePicker";
import { Chip } from "@material-ui/core";
import { ShowToast, toastType } from "../../../utils/toast-service";
class SecurityAndOperations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyId: localStorage.getItem("selectedPropertyIdMultiple"),
      startDate: moment(localStorage.getItem("selectedendDate"))
        .startOf("month")
        .format("L"),
      endDate: moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("L"),
      toUpdateGraph: null,
      selectedPropertyAbbr:
        localStorage.getItem("Abbreviation").split(",") || [],
      isChangedDC: false,
      selectedDatacenterNames:
        localStorage.getItem("selectedPropertyIdMultipleNames") != null
          ? localStorage.getItem("selectedPropertyIdMultipleNames").split(",")
          : []
    };
  }

  componentDidMount() {
    if (this.state.datacenterList == undefined) {
      this.getDataCenterList();
    }
    const endOfMonth = moment()
      .endOf("month")
      .format("L");

    if (moment(endOfMonth) > moment(this.state.endDate)) {
      /* empty */
    } else {
      const startDate = moment()
        .startOf("month")
        .format("L");
      const endDate = moment()
        .endOf("month")
        .format("L");

      localStorage.setItem("selectedstartDate", startDate);
      localStorage.setItem("selectedendDate", endDate);
      localStorage.setItem("MTDDefault", moment().format("MM"));
      this.setState({ startDate: startDate, endDate: endDate });
    }
  }

  /** data center list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        this.setState({
          datacenterList: datacenterList
        });
      }
    );
  };

  /** Text field change */
  _handleTextFieldChange = e => {
    const input = e;
    const output = moment(input, "YYYY-MM");

    localStorage.setItem(
      "selectedstartDate",
      output.startOf("month").format("L")
    );
    localStorage.setItem("selectedendDate", output.endOf("month").format("L"));
    this.setState({
      startDate: output.startOf("month").format("L"),
      endDate: output.endOf("month").format("L")
    });
  };

  /** Update graph */
  toUpdateGraph = values => {
    this.setState({ toUpdateGraph: values });
  };

  /** call on property selection */
  onPropertySelect = (id, selectedDatacenterNames, abbr) => {
    const idList = id.toString();
    localStorage.setItem("selectedPropertyIdMultiple", id);
    this.setState({
      selectedPropertyId: idList,
      selectedDatacenterNames: selectedDatacenterNames,
      selectedPropertyAbbr: abbr
    });
  };

  /** Data change slide date setup */
  handelDateChangesSlideDate = (start, end, typeOfDate) => {
    this.setState({ startDate: start, endDate: end, typeOfDate: typeOfDate });
  };

  /** Abbreviation delete click call */
  abbreviationHandleDelete = value => {
    const { selectedPropertyId } = this.state;
    let propertyIDToRemove = selectedPropertyId.split(",");
    if (propertyIDToRemove.length == 1) {
      ShowToast(
        "You cannot deselect all the Data Centers.",
        toastType.WARNING,
        5000,
        null
      );
      return false;
    }
    const { selectedDatacenterNames, selectedPropertyAbbr } = this.state;
    let propertyNameToRemove = selectedDatacenterNames;
    let propertyAbToRemove = selectedPropertyAbbr;
    const obj = this.state.datacenterList.find(o => o.abbreviation === value);

    propertyIDToRemove = propertyIDToRemove.filter(function(item) {
      return item != obj.propertyID;
    });

    propertyNameToRemove = propertyNameToRemove.filter(function(item) {
      return item !== obj.name;
    });

    propertyAbToRemove = propertyAbToRemove.filter(function(item) {
      return item !== value;
    });
    localStorage.setItem(
      "selectedPropertyIdMultiple",
      propertyIDToRemove.toString()
    );
    localStorage.setItem(
      "selectedPropertyIdMultipleNames",
      propertyNameToRemove.toString()
    );
    localStorage.setItem("Abbreviation", propertyAbToRemove.toString());
    const { isChangedDC } = this.state;

    this.setState({
      selectedPropertyId: propertyIDToRemove.join(","),
      selectedDatacenterNames: propertyNameToRemove,
      selectedPropertyAbbr: propertyAbToRemove,
      isChangedDC: !isChangedDC
    });
  };

  render() {
    const { selectedPropertyId, startDate, endDate } = this.state;

    const SITE_PERSONNEL_ACTIVITY = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.SITE_PERSONNEL_ACTIVITY
    );
    const ACCESS_DENIALS = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.ACCESS_DENIALS
    );
    const GUARD_FORCE_PATROL = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.GUARD_FORCE_PATROL
    );

    const SECURITY_INCIDENTS = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.SECURITY_INCIDENTS
    );
    const SECURITY_INCIDENT_REPORT = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.SECURITY_INCIDENT_REPORT
    );

    const SITE_PERSONNEL_ACTIVITY_GRAPH = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.SITE_PERSONNEL_ACTIVITY_GRAPH
    );
    const GUARD_FORCE_PATROLS_GRAPH = IsSectionVisible(
      SECTIONS.SECURITY_AND_OPERATION,
      SECTIONS.GUARD_FORCE_PATROLS_GRAPH
    );

    return (
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item className={"reports-row-one"} xs={12} sm={4} lg={4}>
              <Box className={" reports-dcList"} pl={1} pt={2} pb={2}>
                <DatacenterList
                  dataSource={this.state.datacenterList}
                  onPropertySelect={this.onPropertySelect}
                  selectedPropertyId={this.state.selectedPropertyId}
                  classTitle={"dc-list-reports"}
                  SeType={"MultipleMaterial"}
                  isChangedDC={this.state.isChangedDC}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={1} lg={1}>
              {""}
            </Grid>

            <Grid item xs={12} sm={7} lg={7} justifyContent={"flex-end"}>
              <Box className={"reports-datepicker"} pt={2} pb={2}>
                <SliderDatePicker
                  handelDateChangesSlideDate={this.handelDateChangesSlideDate}
                  radioSlider={kpiRadioSlider}
                  selectedDate={moment().format(standardDateFormat)}
                  isAll
                />
              </Box>
            </Grid>
            <Grid xs={12} className={"dataCenter-list-div common-colour"}>
              <b>{"Selected Data Centers:"}</b>{" "}
              {this.state.selectedPropertyAbbr.map(value => (
                <Chip
                  label={value}
                  onDelete={() => this.abbreviationHandleDelete(value)}
                  variant={"outlined"}
                  style={{ marginLeft: "4px" }}
                  className={"common-colour"}
                />
              ))}
            </Grid>
            {(SITE_PERSONNEL_ACTIVITY ||
              ACCESS_DENIALS ||
              GUARD_FORCE_PATROL) && (
              <Grid item className={"row-one"} xs={12}>
                <Grid container justifyContent={"center"}>
                  {SITE_PERSONNEL_ACTIVITY && (
                    <Grid item xs={12} sm={4}>
                      <Box mr={1}>
                        <TopWidget
                          title={"Site Personnel Activity"}
                          propertyId={selectedPropertyId}
                          startDate={startDate}
                          endDate={endDate}
                          customUrl={
                            API_URL.SiteVisitorSummary
                              .GetSiteVisitorSummaryByDate
                          }
                          Permission={GetSectionPermission(
                            SECTIONS.SECURITY_AND_OPERATION,
                            SECTIONS.SITE_PERSONNEL_ACTIVITY
                          )}
                        />
                      </Box>
                    </Grid>
                  )}
                  {ACCESS_DENIALS && (
                    <Grid item xs={12} sm={4}>
                      <Box ml={1} mr={1}>
                        {" "}
                        <TopWidget
                          title={"Access Denials"}
                          propertyId={selectedPropertyId}
                          startDate={startDate}
                          endDate={endDate}
                          customUrl={
                            API_URL.security.GetAccessDenialsSummaryByDate
                          }
                          Permission={GetSectionPermission(
                            SECTIONS.SECURITY_AND_OPERATION,
                            SECTIONS.ACCESS_DENIALS
                          )}
                        />
                      </Box>
                    </Grid>
                  )}
                  {GUARD_FORCE_PATROL && (
                    <Grid item xs={12} sm={4}>
                      <Box ml={1}>
                        {" "}
                        <TopWidget
                          title={"Guard-Force Patrols"}
                          propertyId={selectedPropertyId}
                          startDate={startDate}
                          endDate={endDate}
                          customUrl={
                            API_URL.GuardForcePatrolSummary
                              .GetGuardForcePatrolSummaryByDate
                          }
                          toUpdateGraph={this.toUpdateGraph}
                          Permission={GetSectionPermission(
                            SECTIONS.SECURITY_AND_OPERATION,
                            SECTIONS.GUARD_FORCE_PATROL
                          )}
                        />
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}

            {(SECURITY_INCIDENTS ||
              SITE_PERSONNEL_ACTIVITY_GRAPH ||
              SECURITY_INCIDENT_REPORT ||
              GUARD_FORCE_PATROLS_GRAPH) && (
              <Grid item xs={12} md={12}>
                <Box>
                  <Grid container>
                    {SECURITY_INCIDENTS && (
                      <Grid item xs={12} md={7}>
                        <Box mt={1}>
                          <IncidentsTable
                            startDate={this.state.startDate}
                            propertyId={this.state.selectedPropertyId}
                            endDate={this.state.endDate}
                            source={"SecurityAndOperations"}
                          />
                        </Box>
                      </Grid>
                    )}

                    {SITE_PERSONNEL_ACTIVITY_GRAPH && (
                      <Grid item xs={12} md={5}>
                        <Box
                          ml={SECURITY_INCIDENTS == false ? 0 : 1}
                          mt={1}
                          style={{ height: "100%", backgroundColor: "#FFF" }}
                        >
                          <div
                            className={"w-100"}
                            style={{ textAlign: "center", padding: "10px" }}
                          >
                            <HealthAndSafetyBarChart
                              reference={"HealthAndSafetyBarChart2"}
                              propertyId={selectedPropertyId}
                              endDate={this.state.endDate}
                              startDate={this.state.startDate}
                              typeOfDate={this.state.typeOfDate}
                            />
                          </div>
                        </Box>
                      </Grid>
                    )}
                    {GUARD_FORCE_PATROLS_GRAPH && (
                      <Grid
                        item
                        xs={12}
                        md={
                          SECURITY_INCIDENTS == false
                            ? 7
                            : SITE_PERSONNEL_ACTIVITY_GRAPH == false
                            ? 5
                            : 12
                        }
                      >
                        <Box
                          style={{
                            minHeight: "200px",
                            backgroundColor: "#FFF"
                          }}
                          mt={1}
                          ml={
                            SECURITY_INCIDENTS == false &&
                            SITE_PERSONNEL_ACTIVITY_GRAPH == false
                              ? 0
                              : 1
                          }
                        >
                          <div
                            className={"w-100"}
                            style={{ textAlign: "center", padding: "10px" }}
                          >
                            <HealthAndSeftyGrphChart
                              conf={3}
                              reference={"HealthAndSafetyBarChart"}
                              propertyId={this.state.selectedPropertyId}
                              endDate={endDate}
                              startDate={startDate}
                              toUpdateGraph={this.state.toUpdateGraph}
                              typeOfDateNew={this.state.typeOfDate}
                            />
                          </div>
                        </Box>
                      </Grid>
                    )}
                    {SECURITY_INCIDENT_REPORT && (
                      <Grid
                        item
                        xs={12}
                        md={
                          GUARD_FORCE_PATROLS_GRAPH == false
                            ? SECURITY_INCIDENTS == false
                              ? 7
                              : SITE_PERSONNEL_ACTIVITY_GRAPH == false
                              ? 5
                              : 12
                            : 12
                        }
                      >
                        <Box mt={1} ml={1}>
                          <IncidentsTable
                            startDate={startDate}
                            propertyId={this.state.selectedPropertyId}
                            endDate={endDate}
                            source={"maintenance"}
                          />
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default SecurityAndOperations;
